import { render } from "./ResourceBindList.vue?vue&type=template&id=79ce1258"
import script from "./ResourceBindList.vue?vue&type=script&lang=js"
export * from "./ResourceBindList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__